import { AnchorButton } from '@blueprintjs/core';
import AppContentView from 'Components/Generic/AppContentView';
import AppData from 'Data/AppData';
import SiteDialogData from 'Data/SiteDialogData';
import withRouter from 'Lib/hoc/withRouter';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const loginURL = 'auth/login/duo';

const LoginPage = ({ location }) => {
  const [responders, setResponders] = useState([]);

  useEffect(() => {
    let responderArray = [];
    responderArray.push(
      AppData.registerListener('LOGIN_ERROR', loginErrorHandler),
    );
    setResponders(responderArray);
  }, []);

  useEffect(() => {
    if (responders?.length > 0) {
      const { from } = location.state || {};
      const { pathname, search } = from || {};

      window.location = `${loginURL}?pathname=${pathname ?? '/'}&search=${
        search ?? ''
      }`;
    }
  }, [responders]);

  const loginErrorHandler = (err) => {
    let reason = err?.debug || 'Unknown';
    SiteDialogData.open('Login Error', reason);
    window.location = loginURL;
  };

  return (
    <AppContentView hideBreadcrumbs title='Log In'>
      <AnchorButton href={loginURL}>Login</AnchorButton>
    </AppContentView>
  );
};

LoginPage.propTypes = {
  location: PropTypes.object,
};

export default withRouter(LoginPage);
